export default "__VITE_ASSET__O22sW3Az__"